import React from "react";

const lastIcon = `${EASYCOMMERCE.assets}admin/img/icons/ArrowRight.png`;
const nextIcon = `${EASYCOMMERCE.assets}admin/img/icons/Next.png`;

export default function Next({
    baseSlug = "products",
    current = 1,
    total = 1,
}) {
    return (
        <>
            {current < total ? (
                <>
                    <a
                        href={`#/${baseSlug}/page/${parseInt(current) + 1}`}
                        className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:border-ec-primary hover:text-ec-body active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none"
                    >
                        <span>Next</span>

                        <div>
                            <img
                                src={nextIcon}
                                width={8}
                                height={5}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                    </a>
                    <a
                        href={`#/${baseSlug}/page/${total}`}
                        className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:border-ec-primary hover:text-ec-body active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none"
                    >
                        <span>Last</span>

                        <div>
                            <img
                                src={lastIcon}
                                width={10}
                                height={8}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                    </a>
                </>
            ) : (
                <>
                    <div className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:text-ec-body cursor-not-allowed active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none">
                        <span>Next</span>

                        <div>
                            <img
                                src={nextIcon}
                                width={8}
                                height={5}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                    </div>
                    <div className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:text-ec-body cursor-not-allowed active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none">
                        <span>Last</span>

                        <div>
                            <img
                                src={lastIcon}
                                width={10}
                                height={8}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
